<script>
export default {
	name: 'IconSvgDelete',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<template>
	<div>
		<svg :width="size" :height="size" viewBox="0 0 24 24" :fill="color" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				  d="M15.2499 5.55273V5.74712C16.0455 5.82204 16.8345 5.92055 17.6163 6.04198C17.9057 6.08694 18.1942 6.13504 18.4816 6.18625C18.8217 6.24685 19.0496 6.57957 18.9907 6.9294C18.9318 7.27923 18.6083 7.5137 18.2682 7.4531C18.2102 7.44277 18.1522 7.43256 18.0941 7.42249L17.2562 18.6258C17.1561 19.9655 16.07 21 14.7636 21H8.23635C6.93003 21 5.84394 19.9655 5.74375 18.6258L4.90591 7.42249C4.84782 7.43256 4.78977 7.44277 4.73177 7.4531C4.39166 7.5137 4.06819 7.27923 4.00927 6.9294C3.95036 6.57957 4.17831 6.24685 4.51842 6.18625C4.80583 6.13504 5.09427 6.08694 5.38371 6.04198C6.16545 5.92055 6.95446 5.82204 7.75005 5.74712V5.55273C7.75005 4.21176 8.76048 3.06701 10.0962 3.02306C10.5623 3.00773 11.0303 3 11.5 3C11.9697 3 12.4377 3.00773 12.9038 3.02306C14.2395 3.06701 15.2499 4.21176 15.2499 5.55273ZM10.1362 4.30812C10.589 4.29322 11.0436 4.28571 11.5 4.28571C11.9564 4.28571 12.411 4.29322 12.8638 4.30812C13.4927 4.32881 14 4.87194 14 5.55273V5.64928C13.173 5.59763 12.3394 5.57143 11.5 5.57143C10.6606 5.57143 9.82699 5.59763 9.00003 5.64928V5.55273C9.00003 4.87194 9.50734 4.32881 10.1362 4.30812ZM9.84052 9.40386C9.82726 9.04909 9.53689 8.77254 9.19197 8.78619C8.84705 8.79983 8.5782 9.0985 8.59146 9.45328L8.87992 17.1676C8.89319 17.5223 9.18355 17.7989 9.52847 17.7852C9.87339 17.7716 10.1422 17.4729 10.129 17.1181L9.84052 9.40386ZM14.4078 9.45328C14.421 9.0985 14.1522 8.79983 13.8073 8.78619C13.4623 8.77254 13.172 9.04909 13.1587 9.40386L12.8703 17.1181C12.857 17.4729 13.1258 17.7716 13.4708 17.7852C13.8157 17.7989 14.106 17.5223 14.1193 17.1676L14.4078 9.45328Z"
				  :fill="color" />
		</svg>
	</div>
</template>

<style scoped>

</style>